import { getWorkflowStepLongPollResponses } from '@/redux/actions/gravityActions';
import { store } from '@/redux/lib/configureStore';
import workflowScreenSelectors from '@/screens/workflows/redux/selectors/workflowScreenSelectors';

const fetchWorkflowStepLongPollResponses = async ({ workflowId, stepId }) => {
  const state = store.getState();

  const action = workflowScreenSelectors.activeWorkflowStepAppAction(state, stepId);
  const step = workflowScreenSelectors.activeWorkflowStep(state);
  const isMissingArguments = action?.arguments?.some((arg) => arg?.required && !step?.arguments?.[arg?.key]);

  if (isMissingArguments || !action) {
    return;
  }

  const result = await getWorkflowStepLongPollResponses({ workflowId, stepId, isFetch: true });

  return result;
};

export default fetchWorkflowStepLongPollResponses;
